import { Dropdown } from "react-bootstrap";
import styled from "styled-components";

interface YearSelectProps {
  year: number;
  years: number[];
  setYear: (year: number) => void;
}

const StyledDropdown = styled(Dropdown)`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1000;
`;

const YearSelect = ({ year, years, setYear }: YearSelectProps) => {
  return (
    <StyledDropdown
      onSelect={(eventKey: any) => eventKey && setYear(Number(eventKey))}
    >
      <Dropdown.Toggle
        variant="secondary"
        className="fs-6"
        size="lg"
        id="year-dropdown"
        style={{
          width: 250,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {year}
      </Dropdown.Toggle>

      <Dropdown.Menu className="w-100 fs-6">
        {years.map((y) => (
          <Dropdown.Item key={y} eventKey={String(y)} active={y === year}>
            {y}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </StyledDropdown>
  );
};

export default YearSelect;
